import { Event } from 'react-big-calendar';
 
export enum AppointmentSource {
  DIRECT = 'DIRECT',
  WHATSAPP = 'WHATSAPP'
}

export interface Appointment {
  id: string;
  smb_id: string;
  lead_id: string;
  conversation_id?: string;
  lead_phone?: string;
  lead_name?: string;
  lead_status?: string;
  created_at?: string;
  updated_at?: string;
  // Flat fields (normalized from backend's nested slot)
  slot_start: string;
  slot_end: string;
  // Original nested slot from backend (may exist before normalization)
  slot?: {
    start_time: string;
    end_time: string;
  };
  services: string[] | null;
  notes?: string | null;
  status: 'ACTIVE' | 'CANCELLED' | 'COMPLETED' | string;
  source?: AppointmentSource;
  metadata?: Record<string, any>;
  appointment_reminded_lead?: boolean;
  appointment_reminded_smb?: boolean;
}

export interface RBCEvent extends Event {
  id: string;
  resource?: Appointment;
  status?: string;
  modalDate?: string;
}

export interface CreateAppointmentPayload {
  smb_id: string;
  lead_id: string;
  slot_start: string;
  slot_end: string;
  metadata: Record<string, any>;
  services: string[];
  notes: string;
  source: AppointmentSource;
}

export interface UpdateAppointmentPayload {
  slot_start?: string;
  slot_end?: string;
  status?: string;
  metadata?: Record<string, any>;
}

// Raw bookable slot as returned by GET /appointments/slots/
// (ISO strings with the business timezone offset).
export interface AvailableSlotResponse {
  start_time: string;
  end_time: string;
}
